import { Component } from "@angular/core";

@Component({
    selector: "cw-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent {
  title = "QueryApBuilder";

  constructor() {}

  ngOnInit() {
   
  }

  ngOnDestroy() {
  }
}
